import { Route, Switch, Redirect } from 'react-router'
import { useSelector } from 'react-redux'
import { Loader } from 'sfy-react'

import './App.scss'

import AuthorizedRoute from './AuthorizedRoute'
import Login from './routes/Login'
import Error from './routes/Error'
import SessionTimeout from './common/components/UIComponents/SessionTimeout'

const App = () => {
  const showLoader = useSelector((state) => state.common.showLoader)

  return (
    <>
      {showLoader ? <Loader /> : null}
      <Switch>
        <Route exact path='/error' render={() => <Error />} />
        <Route exact path='/forgot-password' render={() => <Login />} />
        <Route exact path='/resetpassword' render={() => <Login />} />
        <Route exact path='/sign-up' render={() => <Login />} />
        <Route exact path='/login' render={() => (localStorage.getItem('isLoggedIn') ? <Redirect to={{ pathname: '/' }} /> : <Login />)} />
        <Route
          path='/'
          render={(props) =>
            localStorage.getItem('isLoggedIn') ? (
              <AuthorizedRoute />
            ) : localStorage.getItem('invalidSession') ? (
              <SessionTimeout />
            ) : (
              <Redirect to={{ pathname: '/login' }} />
            )
          }
        />
      </Switch>
    </>
  )
}

export default App
